import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { useWebsocketStore } from '../../../stores/websocketStore/websocketProvider';
import style from './LoginForm.module.css';
import { Body1, Body3 } from '../../atomic/text/Text';
import TextButton from '../../atomic/buttons/textButton/TextButton';
import { colors } from '../../../colorVars';

export const LoginForm = observer(() => {
  const { userAuthStore } = useWebsocketStore();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const success = await userAuthStore.login(username, password);

    if (success) {
      // Reload the page to reconnect WebSocket with JWT token
      // WebSocket is created on app init and needs the token in the URL
      window.location.href = '/ui/';
    }
  };

  return (
    <div className={style.container}>
      <div className={style.formCard}>
        <Body1 color={colors.lightGrey} fontWeight={700}>
          User Login
        </Body1>

        <form onSubmit={handleSubmit} className={style.form}>
          <div className={style.inputGroup}>
            <label htmlFor="username" className={style.label}>
              <Body3 color={colors.lightGrey} fontWeight={500}>
                Username
              </Body3>
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
              className={style.input}
              disabled={userAuthStore.isLoggingIn}
            />
          </div>

          <div className={style.inputGroup}>
            <label htmlFor="password" className={style.label}>
              <Body3 color={colors.lightGrey} fontWeight={500}>
                Password
              </Body3>
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className={style.input}
              disabled={userAuthStore.isLoggingIn}
            />
          </div>

          {userAuthStore.loginError && (
            <div className={style.errorMessage}>
              <Body3 color={colors.red} fontWeight={500}>
                {userAuthStore.loginError}
              </Body3>
            </div>
          )}

          <div className={style.buttons}>
            <TextButton
              type="submit"
              width="100%"
              fontSize="medium"
              disabled={userAuthStore.isLoggingIn}
            >
              {userAuthStore.isLoggingIn ? 'Logging in...' : 'Login'}
            </TextButton>
          </div>

          <div style={{ marginTop: '16px', textAlign: 'center' }}>
            <a
              href="/ui/forgot-password"
              style={{ color: colors.lightGrey, textDecoration: 'none', cursor: 'pointer' }}
              onClick={(e) => {
                e.preventDefault();
                navigate('/ui/forgot-password');
              }}
            >
              <Body3 color={colors.lightGrey} fontWeight={400}>
                Forgot Password?
              </Body3>
            </a>
          </div>
        </form>
      </div>
    </div>
  );
});
